<template>
  <div class="light-spot-images">
    <div>
      <p v-for="(paragraph,index) in imagesParagraph" :key="index">
        {{paragraph}}
      </p>
    </div>
    <img :src="image" alt="" v-for="(image,index) in images" :key="index">
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'lightSpotImages',
    computed: {
      ...mapState({
        imagesParagraph: state => state.lightSpotImages.paragraph,
        images: state => state.lightSpotImages.images,
      })
    }
  };
</script>

<style scoped lang="less">
  .light-spot-images {
    display: flex;
    justify-content: space-between;
    height: 100vh;
    margin-left: 5vh;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 48vh;
      height: 100%;
      padding: 0 5vh;

      p {
        margin-bottom: 4vh;
        line-height: 1.6;
        font-weight: 100;
        font-size: 2.4vh;
      }
    }

    > img {
      height: 100%;
      width: auto;
      margin-left: .7vh;
    }
  }
</style>
